<img  (error)="setError(item?.id)" [width]="sizeMap[size]" [height]="sizeMap[size]"
 [src]="!hasError(item?.id) ? publicService.countryFlagImage(item?.isoCode3) : '/assets/images/CountryFlags/error.png'">
<!-- <mat-icon  *ngIf="hasError(item?.id)" matListIcon>outlined_flag</mat-icon> -->
<!-- {{!hasError(item?.id) ? publicService.countryFlagImage(item?.isoCode3) : ('/assets/images/CountryFlags/error.png') | json}} -->
